import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { FiPlus } from "react-icons/fi";
import Table from "../../components/Table";
import { viewTeams, deleteTeams } from "../../../states/actions/teamsAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Avatar } from "@mui/material";
import Layout from "../layout/Layout";
import Loading from "../loading/Loading";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const ViewTeams = () => {
  // dispatch
  const dispatch = useDispatch();

  // hooks
  const teams = useSelector((state) => state.teams);
  // use effect
  useEffect(() => {
    dispatch(viewTeams());
  }, []);

  const navigate = useNavigate();

  const handleUpdateTeams = (data) => {
    navigate("/update-teams/" + data.id);
  };

  function handleRemoveTeams(data) {
    if (
      window.confirm(
        "Data deleted permantly. Are you sure to delete completely!",
      )
    ) {
      dispatch(deleteTeams(data.id));
    }
    setTimeout(function () {
      dispatch(viewTeams());
    }, 1000);
  }
  const teamsColumns = [
    {
      accessorKey: "photo", //access nested data with dot notation
      header: "Image",
      size: 100,
      Cell: ({ cell }) => (
        <div>
          <Avatar
            src={`${BaseUrl}${cell.getValue()}`.replace(/([^:]\/)\/+/g, "$1")}
            sx={{ width: 100, height: 100 }}
            variant="rounded"
          />
        </div>
      ),
    },
    {
      accessorKey: "name", //access nested data with dot notation
      header: "Full Name",
    },

    {
      accessorKey: "position", //access nested data with dot notation
      header: "Position Title",
    },

    {
      accessorKey: "linkedn", //access nested data with dot notation
      header: "Linkedn URL",
    },
    {
      accessorKey: "twitter", //access nested data with dot notation
      header: "Twitter",
    },
    {
      accessorKey: "teamMemberBio", //access nested data with dot notation
      header: "Team Member Bio",
    },
  ];
  const { t: translate } = useTranslation(["teams"]);
  return (
    <Layout title={"Teams"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Typography variant="h6">
            {translate("List Aderaw Addisu Teams")}
          </Typography>

          <Link to="/add-teams" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              sx={{ borderRadius: "5px" }}
            >
              {translate("Member")}
            </Button>
          </Link>
        </Box>
        {teams?.teams ? (
          <Table
            data={teams?.teams}
            fields={teamsColumns}
            numberOfRows={teams?.teams?.length}
            enableTopToolBar={true}
            enableBottomToolBar={true}
            enablePagination={true}
            enableRowSelection={true}
            enableColumnFilters={true}
            enableEditing={true}
            enableColumnDragging={true}
            showPreview={true}
            deleteFunction={handleRemoveTeams}
            upDatefunction={handleUpdateTeams}
          />
        ) : (
          <Loading />
        )}
      </Box>
      <ToastContainer />
    </Layout>
  );
};

export default ViewTeams;
